import React, { Component } from "react";
// @ts-ignore
import NavButton from "./components/NavButton";
// @ts-ignore
import ArrowBack from "../../react/icons/ArrowBack";
import { connect } from "react-redux";

import {
  getCustomerById,
  ensureCustomer,
} from "../../redux/modules/customers/reducer";
import { Customer } from "../../redux/modules/customers/reducer";
import {
  getPreviousRouteId,
  getPreviousRoute,
  getCurrentCustomerId,
  getCurrentSiteId,
  getCurrentWorkflowType,
  ROUTE_CUSTOMERS,
  ROUTE_SITES,
  ROUTE_SITE_DASHBOARD,
  ROUTE_SITE_WORKFLOW_LIST_BY_TYPE,
} from "../../redux/modules/route/routes";
import { pushRoute } from "../../redux/modules/route/actions";
import { ensureCurrentSite } from "../../redux/modules/currentSite/asyncActions";
import {
  getCurrentSiteState,
  getRouterState,
  GlobalState,
} from "../../redux/modules/rootReducer";
import { CurrentSiteState } from "../../redux/modules/currentSite/reducer";
import { RouterState } from "../../redux/modules/route/reducer";
import { AppDispatch } from "../../store";

type BackButtonProps = {
  routerState: RouterState;
  currentCustomerId: string;
  currentSiteId: string;
  customer: Customer;
  currentSiteState: CurrentSiteState;
  dispatch: AppDispatch;
};
class BackButton extends Component<BackButtonProps> {
  componentDidMount() {
    const { dispatch, currentCustomerId, currentSiteId } = this.props;

    if (currentCustomerId) {
      dispatch(ensureCustomer(currentCustomerId));
      if (currentSiteId) {
        dispatch(ensureCurrentSite(currentCustomerId, currentSiteId));
      }
    }
  }

  render() {
    const { routerState, dispatch } = this.props;
    const previousRouteId = getPreviousRouteId(routerState);
    const previousRoute = getPreviousRoute(routerState);

    if (!previousRouteId || !previousRoute) {
      return null;
    }

    switch (previousRouteId) {
      case ROUTE_CUSTOMERS:
        return BackButton.renderGoToCustomersList(handleOnClick);
      case ROUTE_SITES:
        return this.renderGoToCustomer(handleOnClick);
      case ROUTE_SITE_DASHBOARD:
        return this.renderGoToSite(handleOnClick);
      case ROUTE_SITE_WORKFLOW_LIST_BY_TYPE:
        return this.renderGoToSiteWorkflowsList(handleOnClick);
      default:
        return null;
    }

    function handleOnClick() {
      dispatch(pushRoute(previousRoute));
    }
  }

  static renderGoToCustomersList(handleOnClick: () => void) {
    return (
      <NavButton
        onClick={handleOnClick}
        label={"Backoffice"}
        icon={<ArrowBack color="#FFFFFF" />}
      />
    );
  }

  renderGoToCustomer(handleOnClick: () => void) {
    const { customer } = this.props;
    if (!customer) {
      return null;
    }

    return (
      <NavButton
        onClick={handleOnClick}
        label={customer.name}
        icon={<ArrowBack color="#FFFFFF" />}
      />
    );
  }

  renderGoToSite(handleOnClick: () => void) {
    const { currentSiteState } = this.props;
    if (!currentSiteState.data) {
      return null;
    }

    return (
      <NavButton
        onClick={handleOnClick}
        label={currentSiteState.data.name}
        icon={<ArrowBack color="#FFFFFF" />}
      />
    );
  }

  renderGoToSiteWorkflowsList(handleOnClick: () => void) {
    const { currentSiteState } = this.props;
    if (!currentSiteState.data) {
      return null;
    }

    return (
      <NavButton
        onClick={handleOnClick}
        label={currentSiteState.data.name}
        icon={<ArrowBack color="#FFFFFF" />}
      />
    );
  }
}

export default connect((state: GlobalState) => {
  const currentCustomerId = getCurrentCustomerId(state.route);
  const currentSiteId = getCurrentSiteId(state.route);
  const currentWorkflowType = getCurrentWorkflowType(state.route);

  const customer = currentCustomerId
    ? getCustomerById(state.customers, currentCustomerId)
    : null;

  return {
    currentCustomerId,
    currentSiteId,
    currentWorkflowType,
    customer,
    currentSiteState: getCurrentSiteState(state),
    routerState: getRouterState(state),
  };
})(BackButton);
